var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0,
    fill: "#000000",
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0,
    fillOpacity: 0,
    strokeOpacity: 0,
    stroke: "#000000",
    fill: "none",
    strokeWidth: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 9.25,
    ry: 9.25,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#000000",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 3.399999976158142,
    ry: 9.399999976158142,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#000000",
    fill: "none",
    strokeWidth: 1.2000000476837158
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,9.70986328125L21,9.70986328125L21,8.50986328125L3,8.50986328125L3,9.70986328125ZM21,14.50986328125L3,14.50986328125L3,15.70986328125L21,15.70986328125L21,14.50986328125Z",
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalOutlined);
export default __webpack_public_path__ + "static/media/globalOutlined.8b3c63c38a18ba529fb07673bf99852b.svg";
export { ForwardRef as ReactComponent };